import axios from "axios";

import { getAuthToken } from "@/features/shared/features/authentication";
import { installAxiosXLastWriteMiddleware } from "@/lib/x-last-write";

import { Configuration } from "./generated";
import {
  DashboardsApi,
  DataApi,
  NavigationElementsApi,
  PagesApi,
  WidgetsApi,
  PublishedApi,
  ExtranetsApi,
  AuthorizationApi,
  UsersApi,
  LocationsApi,
  LegacyApi,
  LegacyWarningsApi,
  DatasetsApi,
  OrganizationsApi,
  StaticMapOverlaysApi,
  TimeRangeSelectorApi,
  TimeZoneSettingsApi,
  ParametersApi,
  MaritimeWarningSettingsApi,
  PublicWarningSettingsApi,
} from "./generated/api";

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();

    if (token?.access_token) {
      config.headers.Authorization = `Bearer ${token.access_token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

installAxiosXLastWriteMiddleware(axiosInstance);

const configuration = new Configuration({
  basePath: import.meta.env.VITE_API_BASE_PATH,
});

export const api = {
  dashboard: new DashboardsApi(configuration, undefined, axiosInstance),
  navigationElements: new NavigationElementsApi(configuration, undefined, axiosInstance),
  pages: new PagesApi(configuration, undefined, axiosInstance),
  widgets: new WidgetsApi(configuration, undefined, axiosInstance),
  published: new PublishedApi(configuration, undefined, axiosInstance),
  extranets: new ExtranetsApi(configuration, undefined, axiosInstance),
  authorization: new AuthorizationApi(configuration, undefined, axiosInstance),
  users: new UsersApi(configuration, undefined, axiosInstance),
  locations: new LocationsApi(configuration, undefined, axiosInstance),
  files: new LegacyApi(configuration, undefined, axiosInstance),
  legacyWarningSettings: new LegacyWarningsApi(configuration, undefined, axiosInstance),
  maritimeWarningSettings: new MaritimeWarningSettingsApi(
    configuration,
    undefined,
    axiosInstance,
  ),
  publicWarningSettings: new PublicWarningSettingsApi(
    configuration,
    undefined,
    axiosInstance,
  ),
  datasets: new DatasetsApi(configuration, undefined, axiosInstance),
  data: new DataApi(configuration, undefined, axiosInstance),
  organizations: new OrganizationsApi(configuration, undefined, axiosInstance),
  staticMapOverlays: new StaticMapOverlaysApi(configuration, undefined, axiosInstance),
  timeRangeSelector: new TimeRangeSelectorApi(configuration, undefined, axiosInstance),
  timezones: new TimeZoneSettingsApi(configuration, undefined, axiosInstance),
  parameters: new ParametersApi(configuration, undefined, axiosInstance),
};

export * from "./types";
export * from "./maritime-widget-configuration.utils";
export * from "./observations-map-widget-configuration.utils";
export * from "./parameter-time-series-configuration.utils";
export * from "./parameter-time-series-chart-result.utils";
export * from "./parameter-time-series-threshold.utils";
export * from "./time-series-widget-configuration.utils";
